import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { StripeService } from './../services/stripe.service';
import { AuthService } from './../services/auth.service';
import { environment } from 'src/environments/environment';
import { AngularFirestore } from '@angular/fire/firestore';
import { AngularFireAuth } from '@angular/fire/auth';
declare var $: any;
declare var Stripe: any;

@Component({
  selector: 'app-contacto',
  templateUrl: './contacto.component.html',
  styleUrls: ['./contacto.component.scss']
})
export class ContactoComponent implements OnInit {
  public formCuenta: FormGroup;
  public formTarjeta: FormGroup;
  public formCupon: FormGroup;
  public planElegido: boolean;
  public plan: string;
  private stripe: any;
  private elements: any;
  private card: any;
  public error: string;
  public tarjetaValida: boolean;
  public procesando: boolean;
  public pagado: boolean;
  public validandoCupon: boolean;
  public errorCupon: string;
  public mensajeCuponValido: string;


  constructor(private auth: AuthService, private stripeService: StripeService, private db: AngularFirestore, private afAuth: AngularFireAuth) {
    /**
     * REGEX:
     * ^ - start of string
     * [A-Z][a-zA-Z]{3,} - Start with uppercasse, having 3 or more ASCII letters
     * (?: [A-Z][a-zA-Z]*){1,2}$- 1 to 2 occurrences of a space followed with one or more ASCII letters
     * $ - end of string.
     */
    this.formCuenta = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email]),
      fullname: new FormControl('', [Validators.required, Validators.minLength(6), Validators.pattern('^[a-zA-ZÀ-ÿ\u00f1\u00d1]{3,}(?: [A-Za-zÀ-ÿ\u00f1\u00d1][a-zA-ZÀ-ÿ\u00f1\u00d1]*){1,2}$')]),
      password: new FormControl('', [Validators.required])
    });
    this.planElegido = true;
    this.plan = 'mensual';
    this.stripe = Stripe(environment.stripe.publishableKeyAF);
    this.elements = this.stripe.elements();
    this.card = this.elements.create('card', {
      hidePostalCode: true
    });
    this.error = '';
    this.tarjetaValida = false;
    this.procesando = false;
    this.pagado = false;
    this.formCupon = new FormGroup({
      cupon: new FormControl('', [Validators.required])
    });
    this.validandoCupon = false;
    this.errorCupon = '';
    this.mensajeCuponValido = '';

  }

  ngOnInit() {
    this.afAuth.auth.signOut();
  }

  ngAfterViewInit(): void {
    //document.body.classList.add("authentication-bg");
    $.App.init();
    $("#progressbarwizard").bootstrapWizard({
      onTabShow: function (t, r, a) {
        var o = (a + 1) / r.find("li").length * 100;
        $("#progressbarwizard").find(".bar").css({ width: o + "%" })
      }
    });
    this.card.mount('#card-element');
    this.card.on('change', (e) => this.cardHandler(e));
    $('#bs-example-modal-lg').modal('show');
    $("#bs-example-modal-lg").on("hidden.bs.modal", function () {
      var vid: any = document.getElementById("modal-video") as HTMLElement;
      vid.muted = true;
    });
  }

  ngOnDestroy(): void {
    $.App.init();
    document.body.classList.remove("authentication-bg");
    this.card.off('change');
    this.card.destroy();
  }

  public submitCuenta(): void {
    console.log(this.formCuenta.valid)
    if (this.formCuenta.valid) {
      document.getElementById('step2').click();
      $('.center-speach').css('display', 'none');
    }
  }

  private cardHandler(event): void {
    const inputAnual = document.getElementById("anual") as HTMLInputElement;
    const inputMensual = document.getElementById("mensual") as HTMLInputElement;
    console.log(inputMensual.checked, inputAnual.checked)
    if (event.complete) {

      this.error = '';
      this.tarjetaValida = true;
      if (inputAnual.checked || inputMensual.checked) {
        this.planElegido = true;
      } else {
        this.planElegido = false
      }
    } else if (event.error) {

      this.error = event.error.message;
      this.tarjetaValida = false;
      if (inputAnual.checked || inputMensual.checked) {
        this.planElegido = true;
      } else {
        this.planElegido = false
      }
    } else {

      this.error = '';
      this.tarjetaValida = false;
      if (inputAnual.checked || inputMensual.checked) {
        this.planElegido = true;
      } else {
        this.planElegido = false
      }
    }
  }



  public selectPlan() {
    const inputAnual = document.getElementById("anual") as HTMLInputElement;
    const inputMensual = document.getElementById("mensual") as HTMLInputElement;
    console.log(inputAnual.checked)
    if (inputAnual.checked) {
      this.planElegido = true;
      this.plan = 'anual';
      console.log(this.procesando, this.planElegido, this.tarjetaValida, this.validandoCupon)
    } else if (inputMensual.checked) {
      this.planElegido = true;
      this.plan = 'mensual';
    } else {
      this.planElegido = false
    }
    console.log(this.procesando, this.planElegido, this.tarjetaValida, this.validandoCupon)
  }

  public async submitPago(): Promise<void> {
    this.procesando = true;
    this.error = '';
    let user: any = null;
    let customerId: string = '';

    try {
      // Step 1: Create Firebase user
      user = await this.auth.signUp(this.formCuenta.value.email, this.formCuenta.value.password);
      await user.updateProfile({ displayName: this.formCuenta.value.fullname });

      // Step 2: Create Stripe token from card
      const config = {
        currency: 'MXN',
        email: this.formCuenta.value.email
      };
      const { token, error: tokenError } = await this.stripe.createToken(this.card, config);
      if (tokenError) throw new Error(tokenError.message);

      // Step 3: Create Stripe customer
      const customer = await this.stripeService.createCustomer(this.formCuenta.value.email, this.formCuenta.value.fullname, token.id);
      customerId = customer.id;

      // Step 4: Determine plan and coupon
      let cupon = '';
      if (this.formCupon.disabled && !this.validandoCupon && this.formCupon.value.cupon.trim()) {
        cupon = this.formCupon.value.cupon.trim();
      }
      const inputAnual = document.getElementById("anual") as HTMLInputElement;
      let planElegido = '';
      if (inputAnual.checked) {
        planElegido = environment.stripe.membershipForAYear;
        cupon = '';
      } else {
        planElegido = environment.stripe.membership;
      }

      // Step 5: Create subscription
      const subscription = await this.stripeService.createSubscription(customerId, planElegido, cupon);

      // Step 6: Save to Firestore (must succeed before showing success)
      await this.db.collection('users').doc(user.uid).set({
        customer: customerId,
        stripeAF: true,
        subscription: subscription.id,
        email: user.email
      }, { merge: true });

      // Step 7: Success — send notification email
      this.sendNewUserNotification(this.formCuenta.value.fullname, this.formCuenta.value.email, customerId);
      this.error = '';
      this.procesando = false;
      this.pagado = true;
      setTimeout(() => { document.getElementById('step3').click(); }, 0);

    } catch (err) {
      this.error = (err && err.message) ? err.message : 'Error durante el registro';
      this.procesando = false;


      // Send error notification
      this.sendErrorNotification(this.formCuenta.value.fullname, this.formCuenta.value.email, this.error);

      // Rollback in reverse order
      if (customerId) {
        await this.stripeService.deleteCustomer(customerId).catch(e => console.error('Rollback: delete customer failed', e));
      }
      if (user) {
        await user.delete().catch(e => console.error('Rollback: delete user failed', e));
      }
    }
  }

  public validarCupon(): void {
    if (this.formCupon.valid) {
      this.validandoCupon = true;
      this.formCupon.disable();
      this.stripeService.getCoupons().then(
        response => {
          const cupones: any[] = response.data;
          const cupon = cupones.find(c => c.code == this.formCupon.value.cupon.trim());

          if (!cupon || !cupon.active || !cupon.coupon.valid) {
            this.errorCupon = 'Cupón inválido.';
            this.validandoCupon = false;
            this.formCupon.enable();
            this.formCupon.reset();
            return;
          }

          this.validandoCupon = false;
          this.errorCupon = '';
          this.mensajeCuponValido = `Descuento de USD $${parseFloat(`${cupon.coupon.amount_off / 100}`)}`;
          return;

          /*if(cupon.valid){
            
          } else{
            
          }*/
        },
        reason => {
          this.errorCupon = reason.error.error.message;
          this.validandoCupon = false;

          this.formCupon.enable();
          this.formCupon.reset();
          return;
        }
      );
    } else {
      this.errorCupon = '';
    }
  }

  public cancelarCupon(): void {
    this.formCupon.enable();
    this.formCupon.reset();
    this.mensajeCuponValido = '';
    return;
  }



  private sendNewUserNotification(name: string, email: string, customerId: string): void {
    const xhr = new XMLHttpRequest();
    const data = { name, email, customer: customerId };
    xhr.open('POST', 'https://us-central1-al-fitness.cloudfunctions.net/userCreated');
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.send(JSON.stringify(data));
  }

  private sendErrorNotification(name: string, email: string, error: string): void {
    const xhr = new XMLHttpRequest();
    const data = { name, email, error };
    xhr.open('POST', 'https://us-central1-al-fitness.cloudfunctions.net/errorEnPago');
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.send(JSON.stringify(data));
  }
}
